import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import DashboardService from "../services/api";
import { appContext } from "../Context/AppContext";
export const GroupSessions = () => {
  const { department, location, fromDate ,toDate } = useContext(appContext);
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  const [workshopData, setWorkshopData] = useState({
    joined_users: 0,
    joining_percentage: 0,
    total_workshop: 0,
  });
  const [workshops, setWorkshops] = useState([]);

  const handleSendmail = () => {
    const recipient = "community@manoshala.com";
    const mailtoUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}`;
    window.open(mailtoUrl);
  };

  const fetchData = async () => {
    try {
      const res = await DashboardService.getWorkshopsData(access_code,department,location,fromDate,toDate);
      const data = res.data;
      const {
        upcoming_workshops,
        joined_users,
        joining_percentage,
        total_workshop,
      } = data;
      setWorkshopData({ joined_users, joining_percentage, total_workshop });
      setWorkshops(upcoming_workshops);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [department,location,fromDate]);

  return (
    <div>
      {" "}
      <h1 style={{ padding: "25px", backgroundColor: "#fff" }}>Workshops</h1>
      <div style={{ padding: "20px" }}>
        <div className="card-container">
          {/* first card */}
          <div style={{ backgroundColor: "#fff", marginRight: "20px" }}>
            <div
              style={{
                fontSize: "20px",
                padding: "15px",
                borderBottom: "1px solid #eeeff2",
              }}
            >
              Overall Numbers
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "15px",
                marginTop: "15px",
              }}
            >
              <div>Total workshops conducted</div>
              <div style={{ fontSize: "30px" }}>
                {workshopData.total_workshop}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 15px 15px 15px",
              }}
            >
              <div>No. of {access_code? "employees":"users"} joined</div>
              <div style={{ fontSize: "30px" }}>
                {workshopData.joined_users}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 15px 15px 15px",
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ maxWidth: "70%" }}>
                  Average no. of {access_code? "employees":"users"} joining workshop
                </div>
              </div>
              <div style={{ fontSize: "30px" }}>
                {workshopData.joining_percentage ?parseFloat(workshopData.joining_percentage.toFixed(2)):"0"}
              </div>
            </div>
          </div>
          {/* second card div */}
          <div
            style={{
              backgroundColor: "#fff",
              marginRight: "20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                padding: "25px",
                backgroundColor: "#fcece8",
                borderBottom: "1px solid #eeeff2",
              }}
            >
              Request a Workshop
            </div>
            <div style={{ padding: "0 10px", marginTop: "25px" }}>
              Have a specific topic in mind?
            </div>
            <div style={{ padding: "0 10px", marginTop: "25px" }}>
              Share a topic with us that you would like your {access_code? "employees":"users"} to gain
              more knowledge on. We will get in touch with you and plan
              together.
            </div>
            <div style={{ margin: "30px 0" }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={handleSendmail}
                style={{
                  color: "white",
                  borderRadius: "20px",
                  padding: "10px",
                  width: "30%",
                }}
              >
                Send Mail
              </Button>
            </div>
          </div>
        </div>

        <div className="bottom-card-container" style={{ margin: "50px 0" }}>
          {workshops.length > 0 &&
            workshops.map((el:any) => (
             el.image && <div className="workshop-card-img" key={el.id}>
                <img
                  src={el.image}
                  alt=""
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
